import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import { BlogCard } from "@/containers/BlogCard";

export const BlogSection: React.FC = () => {
  const { css } = useFela();
  const { bp, colors } = useTheme();
  const { t } = useTranslation();

  return (
    <Grid
      id="BlogSection"
      customStyle={{
        flexDirection: "column",
        background: "url('/svgs/background-bubble.svg') no-repeat 98% 88%",
      }}
      wrapperStyle={{
        position: "relative",
        backgroundImage: `linear-gradient(to top, ${colors.WHITE} 0%, ${colors.LIGHT_BLUE} 100%)`,
      }}
    >
      <div
        className={css({
          textAlign: "center",
        })}
      >
        <Heading as="h2">{t("section/blog:title")}</Heading>
      </div>
      <div
        className={css({
          marginTop: 40,
          display: "flex",
          justifyContent: "space-around",
          flexDirection: "column",
          [bp.FROM_TABLET]: {
            marginTop: 40,
          },
          [bp.FROM_DESKTOP]: { flexDirection: "row", marginTop: 50 },
          nested: {
            "> div:not(:first-of-type)": {
              marginTop: 30,
              [bp.FROM_TABLET]: {
                marginTop: 40,
              },
              [bp.FROM_DESKTOP]: {
                marginTop: 0,
                marginLeft: 30,
              },
            },
          },
        })}
      >
        <BlogCard
          title={t("section/blog:blogs.firstBlog.title")}
          content={t("section/blog:blogs.firstBlog.text")}
          media={{
            type: "IMAGE",
            title: "Blog image",
            src: "/images/blog-xd-to-figma.jpg",
            alt: "XD to Figma Converter",
          }}
          href="https://magicul.io/blog/moving-designs-from-xd-to-figma-easy-or-not"
          buttonLabel={`${t("section/blog:buttonLabel")} >`}
        />

        <BlogCard
          title={t("section/blog:blogs.secondBlog.title")}
          content={t("section/blog:blogs.secondBlog.text")}
          media={{
            type: "IMAGE",
            title: "Blog image",
            src: "/images/convert-figma-xd-sketch.jpg",
            alt: "Figma, XD, Sketch Converter",
          }}
          href="https://medium.com/@sebastiantan/converting-formats-for-ui-design-tools-250b41f2c7f2"
          buttonLabel={`${t("section/blog:buttonLabel")} >`}
        />
        <BlogCard
          title={t("section/blog:blogs.thirdBlog.title")}
          content={t("section/blog:blogs.thirdBlog.text")}
          media={{
            type: "IMAGE",
            title: "Blog image",
            src: "/images/blog-xd-to-sketch.jpg",
            alt: "XD to Sketch Converter",
          }}
          href="https://magicul.io/blog/how-to-import-xd-files-into-sketch"
          buttonLabel={`${t("section/blog:buttonLabel")} >`}
        />
      </div>
    </Grid>
  );
};
